import { useLanguage } from "assets/languages";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";

const FeedbackRemainTimer = (props: {
  render: (remainTimeStr: string) => React.ReactNode;
  dueDate: string;
  onExpired?: () => void;
}) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
  };

  const [secondsLeft, setSecondsLeft] = useState<number>();

  useEffect(() => {
    if (props.dueDate != null || secondsLeft == null) {
      const due = dayjs(props.dueDate).endOf('day');
      const now = dayjs();
  
      setSecondsLeft(Math.max(due.diff(now, 'second'), 0));
    }

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [props.dueDate]);

  useEffect(() => {
    if (props.onExpired != null && secondsLeft === 0) {
      props.onExpired?.();
    }
  }, [secondsLeft]);

  const parseRemainTimeStr = (remainSeconds: number|null|undefined) => {
    if (remainSeconds == null) {
      return '';
    }
    const days = Math.floor(remainSeconds / (24 * 3600));
    const hours = Math.floor((remainSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((remainSeconds % 3600) / 60);
    const seconds = remainSeconds % 60;
    let outputText = `${hours.toString().padStart(2, '0')}`
      + `:${minutes.toString().padStart(2, '0')}`
      + `:${seconds.toString().padStart(2, '0')}`;
    if (days > 0) {
      outputText = `${languageTexts._day(days)} ${outputText}`;
    }
    return outputText;
  };

  return <>{props.render(parseRemainTimeStr(secondsLeft))}</>;
};

export default FeedbackRemainTimer;